import { ConditionalRender } from '@/components/Helpers/ComponentRender/ConditionalRender';
import { FullScreenPageContainer } from '@/components/utils/FullScreenPageContainer';
import { LOGIN_PATH } from '@/constants/paths';
import { useUserStore } from '@/hooks/useUserStore';
import { Button } from '@design-system/Button';
import { Link } from 'react-router-dom';
import useLogout from '@hooks/useLogout.ts';

export const EmailConfirmation = () => {
  const { user: userData } = useUserStore();
  const isLoggedIn = userData ? true : false;
  const handleLogout = useLogout();

  return (
    <FullScreenPageContainer>
      <h2 className="text-4xl font-sans mb-4 mt-4 font-medium">
        Check your inbox
      </h2>
      <div className="flex">
        <p className="font-sans text-tertiary">
          You should receive an email within a few minutes. Click the link in
          the email to reset your password.
        </p>
      </div>
      <ConditionalRender
        conditions={[
          {
            when: isLoggedIn,
            render: (
              <Button
                type="button"
                className="md:max-w-sm py-3 text-white font-semibold bg-black rounded-lg mt-8"
                onClick={handleLogout}
              >
                Return to Login
              </Button>
            ),
          },
          {
            when: !isLoggedIn,
            render: (
              <Link to={LOGIN_PATH}>
                <Button
                  type="button"
                  className="w-full py-3 text-white font-semibold bg-black rounded-lg mt-8"
                >
                  Return to Login
                </Button>
              </Link>
            ),
          },
        ]}
      />
    </FullScreenPageContainer>
  );
};
